module.exports = __webpack_public_path__ + "static/img/02_01.c92b80e3.jpg";